import { jsx as r } from "react/jsx-runtime";
import { forwardRef as a } from "react";
import { b as i, F as m } from "../../floating-ui.react-5e63cf1f.js";
import { DropdownComponent as t } from "./Dropdown.component.es.js";
const s = a((o, n) => {
  const e = i();
  return o.disableParent || e === null ? /* @__PURE__ */ r(m, { children: /* @__PURE__ */ r(t, { ...o, ref: n }) }) : /* @__PURE__ */ r(t, { ...o, ref: n });
});
export {
  s as Dropdown
};
//# sourceMappingURL=Dropdown.container.es.js.map
